// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ff10b4a0","726":"816655bb"}[chunkId] + ".chunk.js";
};